import {useMutation} from "react-query";
import {Endpoints} from "../../enums/invite/Endpoints";
import {QueryParams} from "../../enums/invite/QueryParams";
import {smartposUrl} from "../ApiClient";
import {
    CurrentStageAndConfig,
    getCurrentStageAndConfig
} from "@amzn/rangoli-seller-desktop-async-call-wrapper/src/index";

const { ACCEPT_INVITE } = Endpoints;
const { ACCEPT_INVITE_KEY } = QueryParams;

const acceptInvite = async (inviteeId: string) => {
    const {config: currentStage}: CurrentStageAndConfig = getCurrentStageAndConfig();
    const currentUrl = window.location.href;
    const authPortalUrlReq = {
        domain: currentStage.domain,
        associationHandle: currentStage.associationHandle,
        returnToUrl: currentUrl,
        pageId: currentStage.pageId,
    };
    return await smartposUrl.post(
        `${ACCEPT_INVITE}${inviteeId}`,
        null,
        {
            withCredentials: true,
            headers: {
                AuthPortalUrlRequest: JSON.stringify(authPortalUrlReq),
                'Content-Type': 'application/json',
            },
        }
    );
};

export const useAcceptInviteMutation = () => {
    return useMutation({
        mutationKey: [ACCEPT_INVITE_KEY],
        mutationFn: acceptInvite,
    });
};